/* eslint-disable @typescript-eslint/naming-convention */
export class TestQuestion {
  isExist: boolean | null;
  text: string;
  answerOptions: { text: string; value: string; color: string; isBlock: boolean; isDisabled: boolean } [];

  constructor(text: string, answerOptions?: { text: string; value: string; color: string; isBlock: boolean; isDisabled: boolean }[]) {
    this.text = text;
    this.answerOptions = answerOptions;

  }
}

export class StepTestResult {
  text: string;
  status: TestPassState;
  errorMassage: string;

  constructor() {
    this.status = TestPassState.PENDING;
  }
}

export enum Steps {
  SCREEN = 0,
  NETWORK = 1,
  SYSTEM = 2,
  AUDIO = 3,
  VIDEO = 4,
  MIC = 5,
  SUMMARY = 6,
}

export enum TestPassState {
  PENDING,
  PASSED,
  FAILED
}

export enum SPEED_TEST_STATUS {
  EXCELLENT = 'EXCELLENT',
  GOOD = 'GOOD',
  SUBOPTIMAL = 'SUBOPTIMAL',
  POOR = 'POOR'
}

export class TestResponse {
  command: TestResponseCommands;
  data?: any;

  constructor(command: TestResponseCommands, data?: any) {
    this.command = command;
    this.data = data;
  }
}

export enum TestResponseCommands {
  NEXT,
  SHOW_ERROR,
  REQUEST_QUESTION,
  REQUEST_VIDEO,
  REQUEST_MIC,
  VIDEO_MIC_IS_BLOCK,
  GUEST
}
